import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './expense.module.css';
import { Table } from 'antd';
import ExpenseCheck from './ExpenseCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../report/ReportCheck';
function ExpenseListNeedRead(props) {
    const [list, setList] = useState([]);
    useEffect(() => {
        if (props.list) {
            const arr = props.list.filter((item) => (item.fy_sp_state === '2' || item.fy_sp_state === '3') && item.fy_sp_jd_name === '抄送');
            // 把未读的放前面
            // 假设"未读"定义为jk_sp_state === '2'
            const unread = arr.filter(item => item.fy_sp_state === '2');
            const read = arr.filter(item => item.fy_sp_state === '3');
            read.sort((a, b) => new Date(b.fy_sp_state_time) - new Date(a.fy_sp_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.list]);

    const columns = [
        {
            title: '费用客户  ',
            dataIndex: 'fy_kh_name',
            key: 'fy_kh_name',
            width: "20%",
            render: (_, record) =>  <ExpenseCheck
                                        type='button'
                                        fy_id={record.fy_sp_fy_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        fy_bzd_id={record.fy_bzd_id}
                                        fy_price={record.fy_price}
                                        fy_content={record.fy_content}
                                        fy_date={record.fy_date}
                                        fy_date_end={record.fy_date_end}
                                        fy_bzd_name={record.fy_bzd_name}
                                        fy_bzd_danhao={record.fy_bzd_danhao}
                                        fy_type_id={record.fy_type_id}
                                        fy_type_name={record.fy_type_name}
                                        fy_kh_id={record.fy_kh_id}
                                        fy_kh_name={record.fy_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        fy_num={record.fy_num}
                                        fy_amount={record.fy_amount}
                                        fy_state={record.fy_state}
                                        fy_bm_id={record.fy_bm_id}
                                        fy_bm_name={record.fy_bm_name}
                                        fy_khyhzh_id={record.fy_khyhzh_id}
                                        fy_khyhzh_name={record.fy_khyhzh_name}
                                        fy_image_name={record.fy_image_name}
                                        fy_image_file={record.fy_image_file}
                                        fy_ctime={record.fy_ctime}
                                        fy_sp_id={record.fy_sp_id}
                                        fy_sp_yh_id={record.fy_sp_yh_id}
                                        fy_sp_state={record.fy_sp_state}
                                        fy_sp_fy_kh_name={record.fy_sp_fy_kh_name}
                                        fy_sp_jd_name={record.fy_sp_jd_name}
                                        fy_sp_dsbzd_name={record.fy_sp_dsbzd_name}
                                        fy_sp_dsbzd_id={record.fy_sp_dsbzd_id}
                                        fy_sp_dsbzd_danhao={record.fy_sp_dsbzd_danhao}
                                        fy_sp_uname={record.fy_sp_uname}
                                        fy_sp_ctime={record.fy_sp_ctime}
                                        fy_sp_fy_id={record.fy_sp_fy_id}
                                        
                                    />
        },
        {
            key: 'fy_sp_fy_amount',
            dataIndex: 'fy_sp_fy_amount',
            title: "费用金额",
            width: "6%",            
            render: (text, record) => <span style={{color:'#3366cc'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
      
        {
            key: 'fy_sp_fy_content',
            dataIndex: 'fy_sp_fy_content',
            title: "备注",
            width: "8%",
            render: (text, record) => <Copy title={text}/>
        },
        {
            key: 'fy_sp_dsbzd_name',
            dataIndex: 'fy_sp_dsbzd_name',
            title: "团队名称",
            width: "8%",
            render: (text, record) => <ReportCheck dsbzd_name={record.fy_sp_dsbzd_name} dsbzd_id={record.fy_sp_dsbzd_id} dsbzd_danhao={record.fy_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
        },
        {
            key: 'fy_sp_uname',
            dataIndex: 'fy_sp_uname',
            title: "提交记录",
            width: "8%",
            render: (text, record) => <>{record.fy_sp_uname} {record.fy_sp_ctime}</>,
        },
        {
            key: 'fy_sp_state',
            dataIndex: 'fy_sp_state',
            title: "状态",
            width: "5%",            
            render: (text) => <StateTag state={text} /> 
        },
        {
            key: 'fy_sp_fy_id',
            dataIndex: 'fy_sp_fy_id',
            title: "编号",
            width: "5%",       
        }
      
    ]
    return (
        <>
            <Table 
                className={classes.greenHeader}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='fy_sp_id'
                locale={{
                    emptyText: '暂无费用单' // This will display text when the table is empty
                }}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
            />

        </>
    )
}

export default ExpenseListNeedRead